import { SxProps, Theme } from '@mui/material';
import { clsx, Colors, commonStyles } from '@sweatpals/react-ui-kit';
import { defaultHostColorHex } from 'components/pages/HostPage/host-page.styles';

export const membershipCardStyles = (
	theme: Theme,
	hostPrimaryColorHex?: string,
	drawBackground?: boolean,
	sx?: SxProps<Theme>
) => {
	const commStyles = commonStyles(theme);

	const primaryColorHex = hostPrimaryColorHex || defaultHostColorHex;

	return {
		root: clsx(
			commStyles.flexColumn,
			{
				gap: '24px',

				minWidth: 300,
				maxWidth: 620,
				width: '100%',

				borderRadius: '8px',

				border: '1px solid transparent',

				background: drawBackground
					? `linear-gradient(78.2deg, ${primaryColorHex}44 2.62%, rgba(0, 0, 0, 0.2) 68.3%)`
					: '#191919',

				borderColor: '#353535',
			},
			sx
		),
		content: clsx(commStyles.flexColumn, {
			p: '22px 18px 16px',
		}),
		iconBox: {
			pb: '24px',
		},
		header: clsx(commStyles.flexColumn, {
			gap: '6px',
		}),
		headerTitle: {
			color: '#ebebeb',
			fontWeight: '600',
			fontSize: '20px',
		},
		headerDescription: {
			color: '#F8F7F6CC',
			fontSize: '15px',
			fontWeight: '400',
		},
		typesContainer: clsx(commStyles.flexColumn, {
			pt: '12px',
			gap: '8px',
		}),
		typeBox: clsx(commStyles.flexRow, {
			justifyContent: 'space-between',
			alignItems: 'center',
			gap: '12px',
			p: '12px',
		}),
		typeDivider: {
			borderColor: '#FFFFFF1A',
		},
		typeInfo: clsx(commStyles.flexColumn, commStyles.rowGap('4px')),
		typeName: {
			fontFamily: 'Montserrat, sans-serif',
			fontWeight: '600',
			fontSize: '14px',
			lineHeight: '124%',
			background: 'linear-gradient(114.63deg, #ECECEC 52.13%, rgba(236, 236, 236, 0.17) 174.84%)',
			WebkitBackgroundClip: 'text',
			WebkitTextFillColor: 'transparent',
		},
		typePriceRow: clsx(commStyles.flexRow, {
			alignItems: 'baseline',
		}),
		typePrice: {
			fontFamily: 'Integral CF, sans-serif',
			fontSize: '18px',
			fontWeight: 500,
			lineHeight: '19px',
			color: Colors.white,
		},
		typePeriod: {
			pl: '4px',
			fontFamily: 'Montserrat, sans-serif',
			color: Colors.white_a70,
			fontSize: '14px',
			fontWeight: 600,
			lineHeight: '19px',
		},
		typeGetButton: {
			fontSize: '14px',
			lineHeight: '120%',
			fontWeight: 600,
			p: '10px 24px',
		},
		typeSavingLabel: clsx(commStyles.flex, commStyles.flexCenter, {
			ml: '6px',
			fontFamily: 'Montserrat, sans-serif',
			borderRadius: '25px',
			fontSize: '12px',
			color: Colors.white,
			fontWeight: 600,
			p: '5px 6px 4px 6px',
			backgroundColor: Colors.white_a10,
			userSelect: 'none',
		}),
		typeFullPrice: {
			fontSize: '13px',
			fontWeight: 500,
			lineHeight: '21px',
			background: 'linear-gradient(114.63deg, #ECECEC 52.13%, rgba(236, 236, 236, 0.17) 174.84%)',
			WebkitBackgroundClip: 'text',
			WebkitTextFillColor: 'transparent',
		},
		initialFee: {
			mt: '4px',
			fontSize: '14px',
			fontWeight: 500,
			lineHeight: '120%',
			color: Colors.white_a80,
		},
		period: {
			mt: '4px',
			fontSize: '14px',
			fontWeight: 500,
			lineHeight: '120%',
			color: Colors.white_a80,
		},
	};
};
